import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { DEFAULT_DIFFICULTY_SCALE_BY_MODE, DIFFICULTY_LEVELS } from '../configs/sections-editor/workout-mode-colors.config';
import { WorkoutDifficultyLevel, WorkoutDifficultyScale } from '../types/workout-difficulty.type';

export function getDifficultyLevel(value: number, mode: WorkoutMode): WorkoutDifficultyLevel {
    const scale: WorkoutDifficultyScale = DEFAULT_DIFFICULTY_SCALE_BY_MODE[mode];
    if (value <= scale.easy) return 'easy';
    if (value <= scale.medium) return 'medium';
    if (value <= scale.intermediate) return 'intermediate';
    if (value <= scale.hard) return 'hard';
    return 'expert';
}

export function getHighestDifficultyLevel(datas: { type: WorkoutMode; value: number }[]): WorkoutDifficultyLevel {
    return datas
        .map(({ type, value }) => getDifficultyLevel(value, type))
        .reduce(
            (highest, level) => (DIFFICULTY_LEVELS.indexOf(level) > DIFFICULTY_LEVELS.indexOf(highest) ? level : highest),
            'easy',
        );
}

export function getAverageDifficultyLevel(
    sections: { datas: { type: WorkoutMode; value: number }[]; duration: number }[],
): WorkoutDifficultyLevel | undefined {
    const timedSections: typeof sections = sections.filter(({ duration }) => duration > 0);
    if (!timedSections.length) return undefined;

    const totalDuration: number = timedSections.reduce((total, { duration }) => total + duration, 0);
    const types: WorkoutMode[] = timedSections[0].datas.map(({ type }) => type);

    const averages: { type: WorkoutMode; value: number }[] = types.map((type, index) => ({
        type,
        value:
            timedSections.reduce((total, { datas, duration }) => total + datas[index].value * duration, 0) /
            totalDuration,
    }));

    return getHighestDifficultyLevel(averages);
}

export function getSectionBlockGradient(color: string): string {
    return `linear-gradient(to bottom,
      color-mix(in srgb, ${color} 55%, transparent),
      color-mix(in srgb, ${color} 15%, transparent))`;
}
